var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.notifications),function(notification,idx){return _c('div',{key:idx},[(notification.msg)?_c('notification',{attrs:{"msg":notification.msg,"type":notification.type,"title":notification.title,"auto-dismiss":notification.autoDismiss}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }